import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  Box,
  Typography,
} from "@mui/material";
import WifiOffIcon from "@mui/icons-material/WifiOff";
import useNetworkStatus from "../Hooks/useNetworkStatus";
import { VM_Colors } from "../Styles/VMStyles";

const NetworkOfflineDialog = () => {
  const { isOffline } = useNetworkStatus();

  return (
    <Dialog
      open={isOffline}
      aria-labelledby="network-offline-dialog-title"
      disableEscapeKeyDown
      sx={{ zIndex: (theme) => theme.zIndex.modal + 10 }}
      PaperProps={{
        sx: {
          borderRadius: 2,
          minWidth: { xs: "90%", sm: 420 },
        },
      }}
    >
      <DialogTitle id="network-offline-dialog-title">
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
          <WifiOffIcon sx={{ color: VM_Colors.error }} />
          <Typography component="span" fontWeight={700} fontSize={18}>
            No internet connection
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ color: "text.primary", lineHeight: 1.6 }}>
          Your device appears to be offline. Please check your WiFi or mobile data
          connection. This dialog will close automatically when you are back online.
        </DialogContentText>
      </DialogContent>
    </Dialog>
  );
};

export default NetworkOfflineDialog;
